import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Footer } from '@one-of-one/footer';
import { Reservation } from '../../services/reservation';
import { Observable } from 'rxjs';
import {
  Pack,
  PACKS,
  ParticipantDto,
  Profession,
  RegistrationDto,
  RegistrationPass,
} from '@one-of-one/models';
import { AsyncPipe, DecimalPipe } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ArrowLeft, CopyIon } from '@one-of-one/icons';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-payment-confirmation',
  imports: [
    Footer,
    AsyncPipe,
    DecimalPipe,
    ArrowLeft,
    ClipboardModule,
    CopyIon,
  ],
  templateUrl: './payment-confirmation.html',
})
export class PaymentConfirmation implements OnInit {
  private readonly arouter = inject(ActivatedRoute);
  private readonly registService = inject(Reservation);
  private readonly router = inject(Router);

  bank = environment.BANK;

  registration$!: Observable<RegistrationDto>;
  reservId: string | null = null;
  isLoading = signal(false);

  passes = [
    {
      id: RegistrationPass.PASS_1,
      period: 'Du 21 Au 23',
    },
    {
      id: RegistrationPass.PASS_2,
      period: 'Vendredi',
    },
    {
      id: RegistrationPass.PASS_3,
      period: 'Samedi',
    },
  ];

  ngOnInit(): void {
    this.arouter.paramMap.subscribe((params: ParamMap) => {
      this.reservId = params.get('id');
      if (this.reservId) {
        this.registration$ = this.registService.getReservation(this.reservId);
      }
    });
  }

  goBack() {
    this.router.navigate(['/']);
  }

  participant(regist: RegistrationDto) {
    return regist.participants[0];
  }

  displayProfession(key: Profession) {
    switch (key) {
      case Profession.DOCTOR:
        return 'Médecin';
      case Profession.RESIDENT:
        return 'Résident';
      case Profession.NON_DOCTOR:
        return 'Non médecin';
      case Profession.DPO:
        return 'DPO';
    }
  }

  displayPass(pass?: RegistrationPass) {
    const days =
      pass === RegistrationPass.PASS_1 ? 'Inscription congrès' : 'Pass journée';
    return `${days} (${this.passes.find((p) => p.id === pass)?.period})`;
  }

  downloadQuote() {
    if (this.reservId) {
      this.isLoading.set(true);
      this.registService.getQuote(this.reservId).subscribe((data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'devis.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        this.isLoading.set(false);
      });
    }
  }

  participantAccom(participants: ParticipantDto[], index: number) {
    const participant = participants[index];
    const selectedPack = PACKS.find((p) => p.id === participant.pack)!;
    const roommate = participant.roommate
      ? participants[participant.roommate - 1]
      : null;
    const label =
      participant.pack === Pack.PACK_SUPP
        ? `Supplément Twin (Participant ${roommate?.familyName} ${roommate?.firstName})`
        : selectedPack.label;
    return `${label} ${selectedPack.nights > 0 ? ', ' + selectedPack.nights + ' nuitées' : ''}`;
  }

  copied = false;

  async copyRib(value: string) {
    try {
      await navigator.clipboard.writeText(value);

      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 1500);
    } catch (error) {
      console.error('Clipboard copy failed:', error);
    }
  }
}
